<template>
  <div>
    <div class="subheading font-weight-bold iconColor--text">
      {{ title }}
    </div>
    <div class="body-1 iconColor--text">
      {{ caption }}
    </div>
  </div>
</template>
<script>
export default {
  name: 'SettingHeader',
  props: {
    title: {
      type: String,
      default: '',
      required: true
    },
    caption: {
      type: String,
      default: '',
      required: true
    }
  },
  data() {
    return {};
  }
};
</script>

